import {
  Sprout, TrendingUp, Trophy, Gem, Crown,
  Medal, Award, Star, Shield, Rocket, Flame, Zap,
} from 'lucide-react';

export const LEVEL_ICONS = {
  'sprout':       Sprout,
  'trending-up':  TrendingUp,
  'trophy':       Trophy,
  'gem':          Gem,
  'crown':        Crown,
  'medal':        Medal,
  'award':        Award,
  'star':         Star,
  'shield':       Shield,
  'rocket':       Rocket,
  'flame':        Flame,
  'zap':          Zap,
};

export const iconFor = (key) => LEVEL_ICONS[key] || Trophy;

export const sortLevels = (levels) =>
  [...(levels || [])].sort((a, b) =>
    (a.sort_order - b.sort_order) || (a.min_points - b.min_points),
  );

export const getLevelForScore = (levels, score) => {
  const sorted = sortLevels(levels);
  for (let i = sorted.length - 1; i >= 0; i--) {
    if (score >= sorted[i].min_points) return sorted[i];
  }
  return sorted[0] || null;
};

export const getNextLevel = (levels, score) => {
  const sorted = sortLevels(levels);
  const current = getLevelForScore(sorted, score);
  if (!current) return null;
  const idx = sorted.findIndex((l) => l.id === current.id);
  return sorted[idx + 1] ?? null;
};

export const getLevelProgress = (levels, score) => {
  const current = getLevelForScore(levels, score);
  if (!current) return 0;
  if (current.max_points == null) return 100;
  const span = current.max_points - current.min_points;
  if (span <= 0) return 100;
  return Math.min(Math.max(((score - current.min_points) / span) * 100, 0), 100);
};
